export const equipmentInventoryQueryKeys = {
    all: ['equipmentInventory'] as const,
    details: (inventoryGuid: string) =>
        [...equipmentInventoryQueryKeys.all, 'details', inventoryGuid] as const,
    logsRoot: (inventoryGuid: string) =>
        [...equipmentInventoryQueryKeys.all, 'logs', inventoryGuid] as const,
    logs: (inventoryGuid: string, page: number, countPerPage: number) =>
        [...equipmentInventoryQueryKeys.logsRoot(inventoryGuid), page, countPerPage] as const,
    infiniteLogs: (inventoryGuid: string, countPerPage: number) =>
        [...equipmentInventoryQueryKeys.logsRoot(inventoryGuid), 'infinite', countPerPage] as const,
};
